export const SET_CURRENCY = "SET_CURRENCY";

export const setCurrency = (currency) => ({
    type: SET_CURRENCY,
    payload: currency,
});
